import { RouterView } from "vue-router";
// import { ApplyRouting } from "@/views/purchase/apply/apply.routing";
import { ContractRouting } from "@/views/purchase/contract/contract.routing";
import { ChangeRouting } from "@/views/purchase/change/change.routing";
import { OrderRouting } from "@/views/purchase/order/order.routing";
import { PaymentRouting } from "@/views/purchase/payment/payment.routing";
import { ReceiveRouting } from "@/views/purchase/receive/receive.routing";
import { ContractSettleRouting } from "./contract-settle/contract-settle.routing";
import { SporadicBuy } from "@/views/purchase/sporadicBuy/sporadicBuy.routing";
export const PurchaseRouting = {
  path: "/purchase",
  name: "purchase",
  redirect: "/purchase/contract/list",
  component: RouterView,
  meta: { title: "采购管理", icon: "caigou" },
  children: [
    // ...ApplyRouting,
    ...ContractRouting,
    ...ChangeRouting,
    ...OrderRouting,
    ...ReceiveRouting,
    ...ContractSettleRouting,
    ...PaymentRouting,
    ...SporadicBuy,
  ],
};
